import { render } from "./Login.vue?vue&type=template&id=21f6a55d&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f6a55d"]])

export default __exports__